export default "__VITE_ASSET__OteidP_W__"